import React from "react";
import Report from "../../../components/user/report/reportResFinalFilterList";
import Layout from "../../../components/layouts/verticalLayout";

const ReportResFinalPage = () => {
  return <Layout body={<Report finalResult/>} />;
};

ReportResFinalPage.propTypes = {};

export default ReportResFinalPage;
